<template>
  <div v-if="exitflag" id="app">
    <router-view :nowlogin="nowlogin" />
  </div>
  <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;" v-else-if="!exitflag">
    <div style="text-align: center;        
                      font-size:30px;
                      letter-spacing: 15px;
                      color: brown;"> <div>暂不支持Edge浏览器使用</div>
       
    
    <div>推荐使用谷歌浏览器, <a @click="getannex('https://3class.oss-cn-hangzhou.aliyuncs.com/appVersion/udTIChChromeSetup.exe')" href="#">点击下载</a> </div> </div>
  </div>
</template>

<script>
import {
detail
} from "@/utils/api/user.js";
import Watermark from '@/common/js/wartermark.js';

import { init } from 'console-ban'
init({
  redirect: 'https://www.bilibili.com/video/BV1uT4y1P7CX/'
})
// /* eslint-disable spaced-comment */
// /*!
//   devtools-detect
//   Detect if DevTools is open
//   https://github.com/sindresorhus/devtools-detect
//   by Sindre Sorhus
//   MIT License
//   comment by CC11001100
// */


if (window.location.hostname != "127.0.0.1") {
  document.onkeydown = () => {
    //禁用F12
    if (window.event && window.event.keyCode == 123) {
      return false;
      //禁用ctrl+shift+i,
    } else if (
      window.event.ctrlKey &&
      window.event.shiftKey &&
      window.event.keyCode == 73
    ) {
      return false;
      //屏蔽Shift+F10     
    } else if (window.event.shiftKey && window.event.keyCode == 121) {
      return false;
    }
  };
}

// console.log(navigator.plugins)
function loadStyleString(cssText) {
        var style = document.createElement("style");
        style.type = "text/css";
        try {
          // firefox、safari、chrome和Opera
          style.appendChild(document.createTextNode(cssText));
        } catch (ex) {
          // IE早期的浏览器 ,需要使用style元素的stylesheet属性的cssText属性
          style.styleSheet.cssText = cssText;
        }
        document.getElementsByTagName("head")[0].appendChild(style);
      }
export default {
  name: "App",
  created(){
    this.setwater()
    console.log(navigator.userAgent)
    
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("Edg") > -1) {
        this.exit();
    };

  },
  methods:{
    async setwater(){
      if (localStorage.getItem("id") != undefined) {
          let data = await detail();
              if (data.code != 0) {
                this.$notify.error({
                  title: "错误",
                  message: "用户信息获取失败!",
                });
                return
              } else {
                localStorage.setItem("idcard", data.data.idCard);
                localStorage.setItem("username", data.data.username);
                localStorage.setItem("id", data.data.id);
                localStorage.setItem("phone", data.data.phone);
                localStorage.setItem("slogan", data.data.slogan);
                localStorage.setItem("head_img", data.data.head_img);
                localStorage.setItem("role", data.data.role);
                localStorage.setItem("realName", data.data.realName)
                this.nowlogin = true

                

                Watermark.set(data.data.id)
              }
      }else{
        this.nowlogin = false
        Watermark.set('3C课堂')
      }
    },

    
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };

        xhr.send();
      });
    },
    getannex(file_url) {
      this.getBlob(file_url).then((blob) => {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = 'ChromeSetup.exe'
        link.click();
      });
    },
    exit() {
      this.exitflag = false
    }
  },
  mounted() {
  
  


        let flag =             navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

      if (flag) {
        // 手机
        window.location.href = "https://www.pgyer.com/A3r0k7"
        console.log(1)
      } else {
        // windows
        console.log(2)
      }

  },
  data() {
    return {nowlogin:false,
      exitflag:true,
      windowHeight: 0,
      windowWidth: 0,
    };
  },
};
</script>
<style>
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue